import { render, staticRenderFns } from "./WsOrgsListItem.vue?vue&type=template&id=061b26ce"
import script from "./WsOrgsListItem.vue?vue&type=script&lang=js"
export * from "./WsOrgsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports